module.exports = "<p>\n  campaigncontact-view works!\n</p>\n"